    import React from "react";
import {Box, Checkbox, FormControlLabel, FormGroup, Typography} from "@material-ui/core";

export default function AgentAgreement(props) {
    return (
        <Box m={6}>
            <Typography variant="h5" gutterBottom align="left">
                <b>FMAP Agent Agreement - TERMS AND CONDITIONS</b>
            </Typography>
            <Typography variant="h5" gutterBottom align="left">
                TERM OF AGREEMENT
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                This Agreement will commence on the date and time of acceptance of the Agreement by the Agent and
                continue in full force and effect until terminated by either party pursuant to the provisions
                hereof. <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                AGENT REQUIREMENTS AND DUTIES
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                As a condition of Agent's participation in the <b>FMAP Online Referral Program</b>, the Agent must:
                <ul style={{marginLeft: 16}}>
                    <li>Possess and maintain an active General Lines Agent's License and be in good standing with the
                        Florida Department of Financial Services;
                    </li>
                    <li>Possess and maintain an appointment with at least ten personal residential insurers other than
                        Citizens Property Insurance Company ("CITIZENS") that is authorized to write and is actually
                        writing new personal residential property coverage in the state of Florida;
                    </li>
                    <li>Handle all referrals received from FMAP in the prescribed timeframe required by FMAP, and in a
                        professional and competent manner;
                    </li>
                    <li>Update the solicitation status of all tagged leads within the required timeframe; and </li>
                    <li>Agree not to place any risk for which information has been obtained through FMAP into
                        CITIZENS or with surplus lines carriers for the purposes of quoting or writing coverage.
                    </li>
                </ul>
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                DUTIES OF FMAP
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                FMAP will provide the following services, free of charge, to all Agents participating in the FMAP Online
                Referral Program:
                <ul style={{marginLeft: 16}}>
                    <li>Refer consumers seeking property and casualty insurance in the state of Florida to participating
                        Agents who have indicated their willingness and ability to write such coverage with an
                        authorized insurer;
                    </li>
                    <li>Provide participating Agents access to FMAP's online consumer application database for the
                        purpose of:
                    </li>
                    <ul style={{marginLeft: 16}}>
                        <li>updating the Agent's information;</li>
                        <li>enabling the Agent to create search filters to search, identify and select, in real time,
                            consumers who meet their underwriting criteria; and
                        </li>
                        <li>indicating the outcome of all referrals which the Agent either received from FMAP or
                            solicited directly through the online database;
                        </li>
                    </ul>
                    <li>Provide the Agent electronic notice of those consumers whose insurance needs match the criteria
                        specified in the Agent's search filter.
                    </li>
                </ul>
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                RELATIONSHIP
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Nothing contained herein will be construed to create the relation of employer and employee or principal
                and agent between FMAP and Agent. Nothing contained herein will be construed as giving rise to a joint
                venture relationship between FMAP and the Agent. The Agent will not represent to any person or entity
                that he/she is an employee or agent of FMAP. The Agent will be free to exercise independent judgment as
                to the time, place and manner in which he/she will perform services hereunder.
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                TERMINATION
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Either party may terminate this Agreement for convenience or for cause by giving electronic notice to the other party.
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                GENERAL PROVISIONS
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                <ul style={{marginLeft: 16}}>
                    <li>CONTROLLING LAW. This Agreement is controlled and subject to the laws of the state of Florida.
                    </li>
                    <li>ENTIRE AGREEMENT. This Agreement supersedes all prior agreements between the parties and
                        constitutes the sole and entire agreement setting forth the benefits and obligations of the
                        parties hereto.
                    </li>
                    <li>SEVERABILITY. In the event any provision of this Agreement is held to be invalid by a court of
                        competent jurisdiction, the remainder of this Agreement not held otherwise unenforceable will be
                        deemed valid and enforceable.
                    </li>
                    <li>WAIVER. The failure of FMAP to take any action, or to delay taking any action, respecting any
                        default by the Agent, will not be deemed to constitute a waiver of the default or any subsequent
                        default or an amendment to this Agreement.
                    </li>
                    <li>ASSIGNMENT. Neither party will assign, convey, transfer or otherwise dispose of any of their
                        rights under this Agreement to any person or entity without the prior written approval of the
                        other party.
                    </li>
                </ul>
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                SECURITY
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Citizens Property Insurance Corporation uses physical, technical, and administrative safeguards, based on
                industry standard practices, to protect your private personal information against loss, theft,
                unauthorized access, and disclosure. <br/><br/>
                The agent agrees not to share their FMAP Online Referral Program Login information or to use the FMAP
                system or related information technology resources in a manner that risks the confidentiality,
                availability, or integrity of the FMAP system or related information technology resources.<br/>
                <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                NOTICE OF COLLECTION OF SOCIAL SECURITY NUMBERS
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                The Florida Market Assistance Plan ("FMAP") collection of social security numbers for each of the
                purposes set forth below is imperative for the performance of FMAP duties and responsibilities as
                prescribed by section 627.3515, Florida Statutes, and is authorized by section 119.071(5), Florida
                Statutes. Provision of a social security number is required to process your application for the FMAP
                Online Referral Program.
                <ul style={{marginLeft: 16}}>
                    <li>Processing eligibility for the FMAP Online Referral Program (as prescribed by section 627.3515, Florida Statutes)</li>
                    <li>Verifying agent standing with the Florida Department of Financial Services (as prescribed by section 627.3515, Florida Statutes)</li>
                    <li>Ensuring compliance with US Department of Treasury Office of Foreign Asset Control requirements (as prescribed by Title 31 Code of Federal Regulations Section 501 et seq)</li>
                </ul>
                <br/><br/>
            </Typography>

            <br/>
            <FormGroup>

                <FormControlLabel control={<Checkbox color="primary"  onChange={(event) => {
                    props.setAcceptTC(event.target.checked);
                }}/>} label="I agree to the Agent Agreement"/>
            </FormGroup>
            <br/>
        </Box>
    );
}
